import { enableProdMode, importProvidersFrom } from '@angular/core';

import { environment } from 'projects/internal/r1-component-library/src/lib/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { PublicApiInterceptor } from 'projects/internal/r1-component-library/src/lib/interceptors';
import { NgxsModule } from '@ngxs/store';
import { CloudUserState } from './app/components/states/cloud-user.state';
import { AccountManagerState } from './app/components/states/account-paging.state';
import { NgxsStoragePluginModule, StorageOption } from '@ngxs/storage-plugin';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app/app.routes';
import { provideRouter, RouterModule } from '@angular/router';
import { AppComponent } from './app/app.component';
import { LoginForm } from './app/models/login-form.model';
import { MetricsCard } from './app/models/metrics-card.model';
import { PatchAccountsForm } from './app/models/patch-accounts-form.model';

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideRouter(routes),
        importProvidersFrom(
            NgxsModule.forRoot([CloudUserState, AccountManagerState], { developmentMode: !environment.production }),
            NgxsStoragePluginModule.forRoot({
                storage: StorageOption.SessionStorage,
                keys: '*',
            }),
            NgxsReduxDevtoolsPluginModule.forRoot({ disabled: environment.production }),
            BrowserModule,
            ReactiveFormsModule,
            RouterModule
        ),
        CookieService,
        { provide: HTTP_INTERCEPTORS, useClass: PublicApiInterceptor, multi: true },
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
        LoginForm,
        MetricsCard,
        PatchAccountsForm,
    ],
}).catch(err => console.error(err));
